import authRequest from '../authRequest';

const deleteNoteRule = async (uuid) => {
  try {
    const response = await authRequest(`/note_rules/${uuid}`, {
      method: 'DELETE',
    });
    if (response.status === 200) {
      return true;
    } else {
      throw new Error('Failed to delete note rule');
    }
  } catch (error) {
    console.error('Error deleting note rule:', error);
    throw error;
  }
};

export default deleteNoteRule; 